// math utilities for navlog calculations

export const deg2rad = (d) => (d * Math.PI) / 180;
export const rad2deg = (r) => (r * 180) / Math.PI;

export const norm180 = (d) => {
  let x = d % 360;
  if (x < -180) x += 360;
  if (x > 180) x -= 360;
  return x;
};

export const norm360 = (d) => {
  let x = d % 360;
  if (x < 0) x += 360;
  return x;
};

export const normalizeFt = (s) => String(s || "").trim().toUpperCase();

export function interpolation(cruiseAlt, alt1, alt2, alt3, v1, v2, v3) {
  const ratio =
    cruiseAlt <= alt1
      ? (alt1 - cruiseAlt) / (alt1 - alt2)
      : cruiseAlt > alt1 && cruiseAlt <= alt2
      ? (alt1 - cruiseAlt) / (alt1 - alt2)
      : cruiseAlt > alt2 && cruiseAlt <= alt3
      ? (alt2 - cruiseAlt) / (alt2 - alt3)
      : 0;

  return cruiseAlt <= alt1
    ? v1 - (v1 - v2) * ratio
    : cruiseAlt > alt1 && cruiseAlt <= alt2
    ? v1 - (v1 - v2) * ratio
    : cruiseAlt > alt2 && cruiseAlt <= alt3
    ? v2 - (v2 - v3) * ratio
    : 0;
}

export function tasFromCas(casKt, cruiseAltFt) {
  const CAS = casKt;

  const po = 101325.0;
  const Lx = 0.0065;
  const To = 288.15;
  const gx = 9.80665;
  const Mx = 0.0289664;
  const Rx = 8.31447;

  const h = cruiseAltFt * 0.3048;
  const n = (gx * Mx) / (Rx * Lx);

  const Ux = (Lx * h) / To;
  const p1 = po * Math.pow(1 - Ux, n);

  const standardTempAtFlightLevelC = 15 - (2 * cruiseAltFt) / 1000.0;
  const a1 = Math.sqrt(po / p1);
  const a2 = Math.sqrt((standardTempAtFlightLevelC + 273.15) / To);

  return CAS * a1 * a2;
}